import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {Link} from '@github-ui/react-router'
import {shortOid} from './short-oid'
import {TimelineAuthor} from '../TimelineAuthor'
import {usePullRequestBasePath} from '../../../../stores/selectors'

export function ReviewDismissedText({info}: {info: IssueEventInfo}) {
  const {dismissalMessage, reviewerLogin, afterCommitOid} = info
  const basePath = usePullRequestBasePath()

  return (
    <>
      dismissed {reviewerLogin ? <TimelineAuthor login={reviewerLogin} /> : null}
      {reviewerLogin ? "'s review" : 'a review'}
      {afterCommitOid ? (
        <>
          {' via '}
          <code>
            <Link className="color-fg-muted text-underline" to={`${basePath}/commits/${afterCommitOid}`}>
              {shortOid(afterCommitOid)}
            </Link>
          </code>
        </>
      ) : null}
      {dismissalMessage ? (
        <>
          <br />
          <span>{dismissalMessage}</span>
        </>
      ) : null}
    </>
  )
}
